var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#DE2248"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14286 7.375V6.125C5.14286 5.2962 5.44388 4.50134 5.97969 3.91529C6.51551 3.32924 7.24224 3 8 3C8.75776 3 9.48449 3.32924 10.0203 3.91529C10.5561 4.50134 10.8571 5.2962 10.8571 6.125V7.375C11.1602 7.375 11.4509 7.5067 11.6653 7.74112C11.8796 7.97554 12 8.29348 12 8.625V11.75C12 12.0815 11.8796 12.3995 11.6653 12.6339C11.4509 12.8683 11.1602 13 10.8571 13H5.14286C4.83975 13 4.54906 12.8683 4.33474 12.6339C4.12041 12.3995 4 12.0815 4 11.75V8.625C4 8.29348 4.12041 7.97554 4.33474 7.74112C4.54906 7.5067 4.83975 7.375 5.14286 7.375ZM9.71429 6.125V7.375H6.28571V6.125C6.28571 5.62772 6.46633 5.15081 6.78782 4.79917C7.10931 4.44754 7.54534 4.25 8 4.25C8.45466 4.25 8.89069 4.44754 9.21218 4.79917C9.53367 5.15081 9.71429 5.62772 9.71429 6.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLockIcon);
export default __webpack_public_path__ + "static/media/RedLockIcon.8e2eb4e0e16279574d38296d55bea39b.svg";
export { ForwardRef as ReactComponent };